exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".result-limit .el-select {\n  padding: 10px;\n  width: 100px; }\n", ""]);

// exports
